import { Component, OnInit, Input, HostBinding, EventEmitter, Output, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'cw-input-edit-field',
  templateUrl: './input-edit-field.component.html',
  styleUrls: ['./input-edit-field.component.scss']
})
export class InputEditFieldComponent implements OnInit {
  @Input() value: string;



  @HostBinding('class.block')
  @Input() block: boolean;

  @Output() changed: EventEmitter<string> = new EventEmitter<string>();

  @HostBinding('class.is-editing')
  editing: boolean;
  origValue: string;

  constructor() {
  }

  ngOnInit() {
    //this.origValue = this.value;
  }

  onKeyDown(evt) {
    if (evt.keyCode == 13) {
      this.save();
    }
  }

  edit() {
    this.editing = true;
    this.origValue = this.value;
  }

  cancel() {
    this.value = this.origValue;
    this.editing = false;
  }

  save() {
    this.editing = false;
    if (this.value !== this.origValue) {
      this.changed.emit(this.value);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/input-edit-field/input-edit-field.component.ts